import store from '../store';

const userRoutes = [
	{ 
		path: '/admin/users',
		name: 'users.index', 
		component: require('../pages/users/UsersIndex.vue').default
	},
	{ 
		path: '/admin/users/create',
		name: 'users.create', 
		component: require('../pages/users/UserItemCreate.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_create_user) {
					next();
				}
				else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/users/:id/edit', //user editing themself
		name: 'users.edit', 
		component: require('../pages/users/UserItemEdit.vue').default,
		props(route) {
			const props = { ...route.params };
			props.id = +props.id;
			return props;
		},		
		async beforeEnter(to, from, next) {
			try {
				var user = await store.state.user;
				if (user.id != to.params.id) {
					next('/users/' + store.state.user.id + '/edit');
				}
				else {
					next();
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/users/:id/settings', //admin editing someone else
		name: 'users.settings', 
		component: require('../pages/users/UserItemSettings.vue').default,
		props(route) {
			const props = { ...route.params };
			props.id = +props.id;
			return props;
		},
		async beforeEnter(to, from, next) {
			try {
				var user = await store.state.user;
				var perms = await store.state.perms;
				
				//own user, go to edit page
				if (user.id == to.params.id) {
					next('/users/' + store.state.user.id + '/edit');
				}
				if (perms.can_edit_any_user) {
					next();
				}
				else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/users/:id',
		name: 'users.show', 
		component: require('../pages/users/UserItem.vue').default,
		props(route) {
			const props = { ...route.params };
			props.id = +props.id;
			return props;
		},
	},

];

export default userRoutes;